import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

const Wrap = styled(Flex)`
  align-items: center;

  .Serum {
    transform: translateY(-6px);
  }
`
const Info = styled(Flex)`
  flex-direction: column;
  gap: 4px;
  .booster {
    @media (max-width: 767px) {
      font-size: 14px !important;
      line-height: 140% !important;
    }
  }
`

const CoreUpsellRow = ({ item }) => {
  const { image, price, old_price, name, info } = item
  const isCore = name === "Men"

  return (
    <Wrap ml={[-8]}>
      <Box width={[80]} mr={isCore ? 16 : [0, 0, 16]}>
        <img src={image.url} alt={``} className={name} />
      </Box>
      <Info flex={1}>
        <Flex width={[1]}>
          <Box>
            <TextElementMen
              text={name}
              className={`text-men-secondary-secondary body--large-b ${
                isCore ? "core" : "booster"
              }`}
            />
          </Box>
          <Box ml={["auto"]}>
            <TextElementMen
              text={`$${price}`}
              className={`text-men-secondary-secondary body--large-b ${
                isCore ? "core" : "booster"
              }`}
            />
          </Box>
        </Flex>
        <Box width={[1]}>
          <Flex>
            <Box>
              <TextElementMen
                text={info}
                className={`text-master-base-alt-alt body--regular`}
              />
            </Box>
            <Box ml={["auto"]}>
              <TextElementMen
                text={`$${old_price}`}
                className={`text-master-base-alt-default body--regular line-through`}
              />
            </Box>
          </Flex>
        </Box>
      </Info>
    </Wrap>
  )
}

export default CoreUpsellRow
